import { Accordion, AccordionItem } from "@nextui-org/react";
import { useEffect, useState } from "react";

const FAQS = [
  {
    title: "¿Que es Keperin?",
    content:
      "Keperin es una herramienta para gestionar y optimizar inversiones inmobiliarias y criptoactivos, proporcionando análisis, seguimiento y otras utilidades para obtener un mayor rendimiento de tus inversiones en una plataforma sencilla y fácil de usar.",
  },
  {
    title: "¿Cómo puedo empezar a usar Keperin?",
    content:
      "Empezar a usar Keperin es muy sencillo, solo tienes que registrarte en la plataforma y empezar a añadir tus inversiones para empezar a obtener análisis y seguimiento de tus inversiones.",
  },
  {
    title: "¿Es segura la plataforma?",
    content:
      "Keperin es una plataforma segura, todos los datos de los usuarios están protegidos y encriptados para garantizar la seguridad y privacidad de los usuarios.",
  },
  {
    title: "¿Qué tipo de inversiones puedo añadir en Keperin?",
    content:
      "En Keperin puedes añadir inversiones inmobiliarias y criptoactivos para obtener análisis y seguimiento de tus inversiones.",
  },
  {
    title: "¿Keperin es una plataforma gratuita?",
    content:
      "Keperin es una plataforma gratuita, puedes registrarte y empezar a usar la plataforma sin coste, aunque en el futuro se añadirán funcionalidades premium de pago.",
  },
  {
    title: "¿Cómo puedo contactar con el soporte de Keperin?",
    content:
      "Puedes contactar con el soporte de Keperin a través del formulario de contacto en la plataforma o enviando un email a hello@keperin.com",
  },
  {
    title: "¿Keperin tiene una app móvil?",
    content:
      "Keperin no tiene una app móvil, pero la plataforma es responsive y se puede usar en dispositivos móviles sin problemas.",
  },
  {
    title: "¿Keperin tiene una API?",
    content:
      "Keperin no tiene una API pública, pero si estás interesado en integrar Keperin con otras plataformas, puedes contactar con el soporte de Keperin para más información.",
  },
  {
    title: "¿Keperin tiene una versión en otros idiomas?",
    content:
      "Keperin está disponible en inglés y español, pero en el futuro se añadirán más idiomas a la plataforma.",
  },
  {
    title: "¿Keperin tiene una versión para empresas?",
    content:
      "Keperin no tiene una versión para empresas, pero si estás interesado en una versión para empresas, puedes contactar con el soporte de Keperin para más información.",
  },
  {
    title: "¿Keperin tiene una versión para inversores profesionales?",
    content:
      "Keperin no tiene una versión para inversores profesionales, pero si estás interesado en una versión para inversores profesionales, puedes contactar con el soporte de Keperin para más información.",
  },
  {
    title: "¿Keperin tiene una versión para gestores de inversiones?",
    content:
      "Keperin no tiene una versión para gestores de inversiones, pero si estás interesado en una versión para gestores de inversiones, puedes contactar con el soporte de Keperin para más información",
  },
  {
    title: "¿Keperin tiene una versión para brokers?",
    content:
      "Keperin no tiene una versión para brokers, pero si estás interesado en una versión para brokers, puedes contactar con el soporte de Keperin para más información.",
  },
  {
    title: "¿Keperin tiene una versión para agentes inmobiliarios?",
    content:
      "Keperin no tiene una versión para agentes inmobiliarios, pero si estás interesado en una versión para agentes inmobiliarios, puedes contactar con el soporte de Keperin para más información",
  },
  {
    title: "¿Que tipo de indicadores técnicos puedo configurar?",
    content:
      "En Keperin puedes configurar una gran variedad de indicadores técnicos para analizar tus inversiones, como medias móviles, RSI, MACD, etc.",
  },
  {
    title: "Puedo guardar las facturas de mis inmuebles en Keperin?",
    content:
      "En Keperin puedes guardar las facturas de tus inmuebles para tener un control total de tus inversiones.",
  },
];

export const Faqs = () => {
  const [defaultSelectedKeys, setDefaultSelectedKeys] = useState<any>("all");

  useEffect(() => {
    setDefaultSelectedKeys([]);
  }, []);

  return (
    <div className="w-full mt-2">
      <h1>FAQs</h1>
      <Accordion
        className="p-0"
        itemClasses={{
          title: "uppercase font-medium text-sm",
        }}
        selectedKeys={defaultSelectedKeys}
        onSelectionChange={setDefaultSelectedKeys}
      >
        {FAQS.map((faq, index) => (
          <AccordionItem key={index} title={faq.title}>
            {faq.content}
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
};
